import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForInterface(IAnalyticsAccessor, 'IAnalyticsAccessor');
initMetadataForClass(AnalyticsSession, 'AnalyticsSession');
initMetadataForInterface(IAnalyticsMutator, 'IAnalyticsMutator', VOID, VOID, VOID, [1]);
initMetadataForInterface(IAnalyticsEventTracker, 'IAnalyticsEventTracker', VOID, VOID, VOID, [1]);
initMetadataForClass(AnalyticsEventTracker, 'AnalyticsEventTracker', VOID, VOID, [IAnalyticsEventTracker], [1]);
//endregion
function IAnalyticsAccessor() {
}
function AnalyticsSession(id) {
  this.e9z_1 = id;
}
protoOf(AnalyticsSession).toString = function () {
  return 'AnalyticsSession(id=' + this.e9z_1 + ')';
};
protoOf(AnalyticsSession).hashCode = function () {
  return getStringHashCode(this.e9z_1);
};
protoOf(AnalyticsSession).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof AnalyticsSession))
    return false;
  var tmp0_other_with_cast = other instanceof AnalyticsSession ? other : THROW_CCE();
  if (!(this.e9z_1 === tmp0_other_with_cast.e9z_1))
    return false;
  return true;
};
function IAnalyticsMutator() {
}
function IAnalyticsEventTracker() {
}
function AnalyticsEventTracker(accessor, mutator, sessionDataProvider, environmentProvider) {
  this.f9z_1 = accessor;
  this.g9z_1 = mutator;
  this.h9z_1 = sessionDataProvider;
  this.i9z_1 = environmentProvider;
}
//region block: exports
export {
  IAnalyticsAccessor as IAnalyticsAccessor8msxm7d2po53,
  AnalyticsSession as AnalyticsSessionok9n7iyuxvoj,
  IAnalyticsMutator as IAnalyticsMutator1o33d6dg8g9hg,
  AnalyticsEventTracker as AnalyticsEventTrackerk8518ys1zbmt,
  IAnalyticsEventTracker as IAnalyticsEventTracker3dt8wr4gltex1,
};
//endregion

